import { gql } from '@apollo/client';
import useGQLQuery from 'src/lib/graphql/hooks/useGQLQuery';
const QP_AUTHOR_QUERY = gql `
  query EP_QPAuthor($qpID: String!) {
    ep_qp(qpID: $qpID) {
      id
      type
      author {
        id
        details {
          avatarURL
          firstName
          lastName
          userName
        }
      }
    }
  }
`;
export function useQPAuthorQuery(qpID, options) {
    return useGQLQuery(QP_AUTHOR_QUERY, {
        variables: {
            qpID,
        },
        ...options,
    });
}
